import { Component, Input } from "@angular/core";
import { ValidationErrors } from "@angular/forms";

@Component({
    selector: 'app-input-errors',
    template: '<mat-error *ngFor="let message of errorMessages">{{ message }}</mat-error>'
}) export class InputErrorsComponent {
    @Input() errors?: ValidationErrors;

    get errorMessages() {
        return this.errors ? Object.values(this.errors) : [];
    }
}